import pRetry from 'p-retry';
import { buildUserIdPayload } from '../utils/userIdPayload';

export async function login({ platform, userId, login, password, number, language }) {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/login`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...buildUserIdPayload(platform, userId),
                indifier: login,
                password,
                number,
                language,
            }),
        },
    );
    return await response.json();
}

export async function callback({
    platform,
    userId,
    access_token,
    contract_number,
    language,
    first_name,
    middle_name,
    last_name,
    phone,
    first,
    session,
}) {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/callback`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...buildUserIdPayload(platform, userId),
                access_token,
                contract_number,
                language: language || null,
                first_name: first_name || null,
                middle_name: middle_name || null,
                last_name: last_name || null,
                phone: phone || null,
                first: first || null,
                session: session || null,
            }),
        },
    );
}

export async function callback_less({
    platform,
    userId,
    access_token,
    contract_number,
    language,
    first_name,
    middle_name,
    last_name,
    phone,
    first,
    session,
}) {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/callback_less`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...buildUserIdPayload(platform, userId),
                contract_number,
                first_name: first_name || null,
                language: language || null,
                middle_name: middle_name || null,
                last_name: last_name || null,
                phone: phone || null,
                first: first || null,
                session: session || null,
                access_token,
            }),
        },
    );
}

export const getContractsFullByID = async ({ platform, userId }) => {
    return await pRetry(
        async () => {
            return await _getContractsFullByID({ platform, userId });
        },
        { retries: 5 },
    );
};

export const _getContractsFullByID = async ({ platform, userId }) => {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/get_contracts`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                userId ? buildUserIdPayload(platform, userId) : { tg_id: '664942774' },
            ),
        },
    );

    const data = await response.json();

    return data.result ?? [];
};

/**
 * Отключить договор (деструктивное действие).
 * @param {{ platform: string, userId: string, contract_number: string }} params
 * @returns {Promise<void>}
 */
export const deleteContract = async ({ platform, userId, contract_number }) => {
    return await pRetry(
        async () => {
            return await _deleteContract({ platform, userId, contract_number });
        },
        { retries: 5 },
    );
};

/**
 * @param {{ platform: string, userId: string, contract_number: string }} params
 * @returns {Promise<void>}
 */
export const _deleteContract = async ({ platform, userId, contract_number }) => {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/delete_contract`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...buildUserIdPayload(platform, userId),
                contract_number,
            }),
        },
    );

    if (!response.ok) {
        throw new Error(
            `Failed to delete contract ${contract_number}: ${response.status} ${response.statusText}`,
        );
    }
};
